import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./contentRotator.scss";

import ContentRotatorProps, { TItem } from "./contentRotator.types";
import React, { Fragment, useEffect, useState } from "react";

import Button from "../../atoms/button/button";
import Slider from "react-slick";

const ContentRotator = ({
  title,
  cmsTitle,
  items,
  align,
  btnLink,
  btnText,
}: ContentRotatorProps) => {
  const [nodesShuffle, setNodesShuffle] = useState<TItem[]>([]);
  useEffect(() => {
    setNodesShuffle(shuffleArray(items));
  }, []);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();
  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 1);
  };
  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 1);
  };
  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;
  const isActiveNext = (_true: any, _false: any) =>
    sliderIndex < items.length - 1 ? _true : _false;
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };
  function shuffleArray(array: TItem[]) {
    let i = array.length - 1;
    for (; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }
  return (
    <div
      className={`o-content-rotator ${
        align && `o-content-rotator--align-${align}`
      }`}
    >
      {title && <h2 className="o-content-rotator__title">{title}</h2>}
      <div className="o-content-rotator__background"></div>
      <Slider
        ref={(_slider) => setSlider(_slider)}
        {...settings}
        className="o-content-rotator__carrusel"
      >
        {nodesShuffle?.map((node, index) => {
          return (
            <Fragment key={index}>
              <div className="o-content-rotator__carrusel__content">
                <img
                  className="o-content-rotator__carrusel__content__cover"
                  src={node.imgUrl.images.fallback.src}
                  alt={"imagen rotador"}
                />
                <div className="o-content-rotator__carrusel__background">
                  <article className="o-content-rotator__carrusel__content__text">
                    {node.title && (
                      <h3 className="o-content-rotator__carrusel__content__text__title">
                        {node.title}
                      </h3>
                    )}
                    {node.description && (
                      <div className="o-content-rotator__carrusel__content__text__description">
                        {node.description}
                      </div>
                    )}
                    <div className="o-content-rotator__carrusel__content__text__action">
                      {node.btnText ? (
                        <Button
                          id={"buttonContentRotator-" + index}
                          type="link"
                          href={node.btnLink}
                          classname={`secondary ${
                            cmsTitle.split(">")[0] === "Empresas red de amor "
                              ? "enterprises"
                              : ""
                          }`}
                          text={node.btnText}
                          isDisabled={false}
                          gtmMark={node.gtm}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </article>
                </div>
              </div>
            </Fragment>
          );
        })}
      </Slider>
      {btnText && (
        <div className="o-content-rotator__btn">
          <Button
            type="link"
            href={btnLink}
            classname={`primary ${
              cmsTitle.split(">")[0] === "Empresas red de amor "
                ? "enterprises"
                : ""
            }`}
            text={btnText}
            isDisabled={false}
          />
        </div>
      )}
      <div
        className={`arrow-content arrow-content__left ${
          nodesShuffle.length > 1 ? "shown" : "hiden"
        }`}
        onClick={isActiveBack(goToBack, undefined)}
      >
        <div className="arrows">
          <div className="arrows-contain">
            <div
              className={isActiveBack(
                "arrow icon-chevron-left active",
                "arrow icon-chevron-left"
              )}
            />
          </div>
        </div>
      </div>
      <div
        className={`arrow-content arrow-content__right ${
          nodesShuffle.length > 1 ? "shown" : "hiden"
        }`}
        onClick={isActiveNext(goToNext, undefined)}
      >
        <div className="arrows">
          <div className="arrows-contain">
            <div
              className={isActiveNext(
                "arrow icon-chevron-right active",
                "arrow icon-chevron-right"
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContentRotator;
